import humanInsight from './human-insight/human-insight.reducer';
import insightExplorer from './insight-explorer/insight-explorer.reducer';
import insight from './insight/insight.reducer';
import performanceInsight from './performance-insight/performance-insight.reducer';
import { tdcfForm } from './tdcf-form/tdcf-form.reducer';

export default {
    ...insight,
    ...insightExplorer,
    ...humanInsight,
    ...performanceInsight,
    tdcfForm,
};
